import React, {Component} from 'react';

class Program extends Component {
    render() {

        return (
            <div>
                <div className={"Program-Header"}>
                    <h1 className={"Header-Content"} >Program</h1>

                </div>
                <h2 className={"Program-Header2"}>2023 Conference Schedule is to be announced</h2>
                <div className={"Program-Content-Wrapper"}>



                </div>

            </div>

        );
    }
}

export default Program;